// jQuery wrapper
(function ($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function () {

		$('body').addClass('active');

		// InView - Animate when in viewport
		$('.animate').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass('ani-trigger');
			}
		});
		$('.animate-bg').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass('ani-trigger');
			}
		});
		$('.svg-animate').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass("active");
			}
		})

		// Menu - Hamburger
		$('.menu-trigger').click(function (event) {
			event.preventDefault();

			var target = $(this).data('target');

			$(this).toggleClass('is-active');
			$(target).toggleClass('open');
			$('body').toggleClass('mobile-menu-open');
		})


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - (headerHeight);
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
				scrollTop: scrollPosition
			}, 1000);
		});


		// Team List - Filtering
		if ($('.filters').length > 0) {
			// Filter Toggle 
			$('.filters').on('click', '.filter-toggle', function (event) {
				var target = $(this).data('target');

				$(target).toggleClass('open');
			});

			// Filtering
			var filter_list = $('.filter-list');
			$(filter_list).imagesLoaded().progress(function () {
				$(filter_list).isotope({
					itemSelector: '.item',
					layoutMode: 'fitRows',
					fitRows: {
						equalheight: true
					},
					filter: concatValues(filters)
				});
			});

			var filters = {};

			function getQueryFilterValues() {
				var params = new URLSearchParams(window.location.search);
				var queryFilters = {};

				$('.filters .button-group').each(function () {
					var group = $(this).attr('data-filter-group');
					if (!group) {
						return;
					}

					var value = params.get(group);
					if (value) {
						queryFilters[group] = value;
					}
				});

				return queryFilters;
			}

			function urlParamToFilterValue(filterGroup, paramValue) {
				var buttonGroup = $('.filters .button-group[data-filter-group="' + filterGroup + '"]');
				if (!buttonGroup.length) {
					return '';
				}

				if (!paramValue || paramValue === 'all') {
					var allButton = buttonGroup.find('[data-value="all"]').first();
					return allButton.length ? allButton.attr('data-filter') : '.all-' + filterGroup;
				}

				return '.' + paramValue;
			}

			function filterValueToUrlParam(filterValue) {
				if (!filterValue) {
					return null;
				}

				if (filterValue.indexOf('.all-') === 0) {
					return 'all';
				}

				return filterValue.replace(/^\./, '');
			}

			function setFilterButtonState(filterGroup, filterValue, updateToggleText) {
				var buttonGroup = $('.filters .button-group[data-filter-group="' + filterGroup + '"]');
				if (!buttonGroup.length) {
					return;
				}

				var button = buttonGroup.find('[data-filter="' + filterValue + '"]');
				if (!button.length) {
					button = buttonGroup.find('[data-value="all"]').first();
				}

				buttonGroup.find('button').removeClass('active');
				button.addClass('active');

				if (updateToggleText) {
					var toggle = button.closest('.filter-wrap').find('.filter-toggle').first();
					if (toggle.length) {
						toggle.text($.trim(button.text()));
					}
				}
			}

			function updateUrlFilters(filters) {
				var searchParams = new URLSearchParams(window.location.search);

				$.each(filters, function (group, value) {
					var paramValue = filterValueToUrlParam(value);
					if (!paramValue || paramValue === 'all') {
						searchParams.delete(group);
					} else {
						searchParams.set(group, paramValue);
					}
				});

				var newUrl = window.location.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '') + window.location.hash;
				window.history.replaceState(null, '', newUrl);
			}

			function setInitialFilterState() {
				$('.filters .button-group').each(function () {
					var filterGroup = $(this).attr('data-filter-group');
					if (!filterGroup) {
						return;
					}

					var allButton = $(this).find('[data-value="all"]').first();
					if (allButton.length) {
						filters[filterGroup] = allButton.attr('data-filter');
					}
				});

				var queryFilters = getQueryFilterValues();
				$.each(queryFilters, function (filterGroup, paramValue) {
					filters[filterGroup] = urlParamToFilterValue(filterGroup, paramValue);
				});

				$.each(filters, function (filterGroup, value) {
					setFilterButtonState(filterGroup, value, queryFilters.hasOwnProperty(filterGroup));
				});
			}

			setInitialFilterState();

			$('.filters .button-group').on('click', 'button', function (event) {
				var button = $(event.currentTarget);

				// get group key
				var buttonGroup = $(button).parents('.button-group');
				var filterGroup = $(buttonGroup).attr('data-filter-group');

				// set filter for group
				filters[filterGroup] = $(button).attr('data-filter');

				// combine filters
				var filterValue = concatValues(filters);

				// set filter for Isotope
				$(filter_list).isotope({ filter: filterValue });

				// update URL state
				updateUrlFilters(filters);

				$('.filter-wrap').removeClass('open');
				setFilterButtonState(filterGroup, filters[filterGroup], true);
			});
		}


		// Accordion list (FAQ setc.)
		if ($('.accordion-list').length > 0) {
			$('.accordion-list .answer:not(.active)').hide();
			// var allPanels = $('.accordion-list .answer');

			$('.accordion-list .accordion-toggle').click(function () {
				// var targetParent = $(this).data('parent');
				var target = $(this).data('target');

				// console.log(targetParent);

				if ($(target).hasClass('active')) {
					$(this).removeClass('current');
					$(target).removeClass('active').slideUp(250);

				} else {
					$('.accordion-list .accordion-toggle').removeClass('current');
					$('.accordion-list .answer').removeClass('active').slideUp(250);

					$(this).addClass('current');
					$(target).addClass('active').slideDown(250);
				}

				// Prevent default 'link' behaviour
				return false;
			});
		}

		// Homepage stat counters
		$('#statistics').on('inview', function (event, isInView) {
			if (!isInView) return;

			const numbers = document.querySelectorAll('#statistics span.number');

			numbers.forEach(function (el) {
				// Guard: don't re-animate if already started
				if (el.dataset.animated) return;
				el.dataset.animated = 'true';

				animateCounter(el);
			});
		});


		// Featured Treatments / Spotlight
		// Desktop
		if ($('#fund-cards').length > 0) {
			$('#fund-cards .card .trigger').click(function () {
				var allCards = $('#fund-cards .card');
				var current = $(this).parent();

				if (current.hasClass('active')) {
					// Do nothing if hovering active card
				} else {
					allCards.removeClass('active');
					$(current).addClass('active');

				}
			});

			$('.fund-btn').on('click', function (event) {
				event.preventDefault();

				var target = $(this).data('target'),
					total = $('span.total').data('total'),
					currentSlide = $('#fund-cards .card.active').data('order');

				// If button active
				if ($(this).hasClass('fund-next')) {

					if (currentSlide == total) {
						// Reset count if last slide
						var nextSlide = 1;
					} else {
						// Go to next slide
						var nextSlide = currentSlide + 1;
					}

					$('#fund-cards .card').removeClass('active');
					$('#fund-cards .card[data-order="' + nextSlide + '"]').addClass('active');

				} else {

					if (currentSlide == 1) {
						// Reset count if last slide
						var prevSlide = total;
					} else {
						// Go to next slide
						var prevSlide = currentSlide - 1;
					}

					$('#fund-cards .card').removeClass('active');
					$('#fund-cards .card[data-order="' + prevSlide + '"]').addClass('active');

				}
			});
		}
		// Mobile
		if ($('#fund-cards').length > 0) {

			// Carousel
			$('.fund-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				infinite: false,
				centerMode: false,
				prevArrow: $('.fund-prev-mob'),
				nextArrow: $('.fund-next-mob'),
			});
		}


		/***
		 * Carousels
		 ***/
		// Homepage Hero
		if ($('.hero-carousel').length > 0) {
			$('.hero-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
			});

			$('.hero-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$('.hero-carousel .bg-img').removeClass('ani-trigger');
			});
			$('.hero-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
				$('.hero-carousel .slick-active .bg-img').addClass('ani-trigger');
			});
		}

		// Portfolio Carousel
		if ($('.portfolio-carousel').length > 0) {
			$('.portfolio-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				prevArrow: $('.portfolio-controls .portfolio-prev'),
				nextArrow: $('.portfolio-controls .portfolio-next'),
				infinite: true,
				centerMode: false,
			});
		}

		// Related Sections Carousel
		if ($('.related-carousel').length > 0) {
			$('.related-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				prevArrow: $('.related-controls .related-prev'),
				nextArrow: $('.related-controls .related-next'),
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							centerMode: false,
						}
					},
				]
			});
		}

		// Case Studies Carousel
		if ($('.case-studies-carousel').length > 0) {
			$('.case-studies-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				prevArrow: $('.case-studies-controls .case-studies-prev'),
				nextArrow: $('.case-studies-controls .case-studies-next'),
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							centerMode: false,
						}
					},
				]
			});
		}

		// Related News Carousel
		if ($('.news-carousel').length > 0) {
			$('.news-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				prevArrow: $('.news-controls .news-prev'),
				nextArrow: $('.news-controls .news-next'),
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							centerMode: false,
						}
					},
				]
			});
		}

		// Funds - Related Investment Carousel
		if ($('.fund-inv-carousel').length > 0) {
			$('.fund-inv-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: false,
				// prevArrow: $('.fund-inv-controls .fund-inv-prev'),
				// nextArrow: $('.fund-inv-controls .fund-inv-next'),
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
							centerMode: false,
						}
					},
				]
			});

			// Carousel arrows (multiple carousels with same class)
			$('.fund-inv-controls button').click(function (e) {
				e.preventDefault();
				var target = $(this).data('target');

				if ($(this).hasClass('carousel-next')) {
					$(target).slick('next');
				} else {
					$(target).slick('prev');
				}
			});
		}


		// Disclaimer pop-up / cookie
		if ($('#disclaimer').length > 0) {
			$('#disclaimer .disclaimer-agree input').change(function () {
				if ($(this).is(':checked')) {
					$('.disclaimer-button').removeAttr('disabled');
				} else {
					$('.disclaimer-button').attr('disabled', 'disabled');
				}
			})
		}

		// Set Cookie function
		function createCookie(name, value, days) {
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				var expires = "; expires=" + date.toGMTString();
			} else var expires = "";
			document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
		}
		// Privacy Policy Cookies   
		function dalmoreDisclaimer() {
			// Check cookie 
			if ($.cookie('dalmoreDisclaimer') != "accepted") {
				$('#disclaimer').fadeIn();
				$('body').addClass('disclaimer-open');
			}

			//Assign cookie on click
			$('#disclaimer button').on('click', function () {
				createCookie("dalmoreDisclaimer", "accepted", 90); // Cookie expires in 90 days
				$('#disclaimer').fadeOut();
				$('body').removeClass('disclaimer-open');
			});
		}
		// Run cookie policy function
		dalmoreDisclaimer();

	}); // End Document Ready


	// On load
	$(window).on('load', function () {

		// Header bar scrolled
		scrollbarState();

		// Sticky Filter
		stickyFilter();

		carouselEqualHeights();

	});


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

		// Sticky Filter
		stickyFilter();

	});

	// On Resize
	$(window).on('resize', function () {

		carouselEqualHeights();

	});


	/***
	** Functions
	***/

	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		if ($(document).scrollTop() > navHeight) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	// Sticky Filter
	function stickyFilter() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Header Banner height
		var headerHeight = $('.header-banner').outerHeight();

		if ($(document).scrollTop() > headerHeight) {
			$('.sticky-filter').addClass('sticky').css('top', navHeight + 'px');
		} else {
			$('.sticky-filter').removeClass('sticky').css('top', 'auto');
		}
	}

	// Hero video autoplay on interaction
	function heroAutoplay() {
		let videoLoaded = false;

		function loadVideo() {
			if (!videoLoaded) {
				document.querySelectorAll('.onload-iframe').forEach(function (iframe) {
					const baseSrc = iframe.getAttribute('data-src');
					iframe.setAttribute('src', baseSrc + '&autoplay=1');
					iframe.classList.add('loaded');
				});
				videoLoaded = true;
				// Remove event listeners after first trigger
				events.forEach(event => {
					document.removeEventListener(event, loadVideo);
				});
			}
		}

		const events = ['mousemove', 'click', 'keydown', 'touchstart'];
		events.forEach(event => {
			document.addEventListener(event, loadVideo, { once: true });
		});
	}

	// Carousel - Equal heights
	function carouselEqualHeights() {
		$('.carousel.equal').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	}

	// Homepage stat counters
	function animateCounter(el) {
		const target = parseFloat(el.textContent);
		const decimals = parseInt(el.dataset.decimals) || 0;
		const duration = 2000;
		const frameRate = 1000 / 60;
		const totalFrames = Math.round(duration / frameRate);
		let frame = 0;

		function easeOut(t) {
			return 1 - Math.pow(1 - t, 3);
		}

		const counter = setInterval(function () {
			frame++;
			const progress = easeOut(frame / totalFrames);
			const current = (progress * target).toFixed(decimals);

			el.textContent = parseFloat(current).toLocaleString(undefined, {
				minimumFractionDigits: decimals,
				maximumFractionDigits: decimals,
			});

			if (frame === totalFrames) {
				el.textContent = target.toLocaleString(undefined, {
					minimumFractionDigits: decimals,
					maximumFractionDigits: decimals,
				});
				clearInterval(counter);
			}
		}, frameRate);
	}

	// Isotope Filtering - concatanate multiple button group values
	function concatValues(obj) {
		var value = '';
		for (var prop in obj) {
			value += obj[prop];
		}
		return value;
	}

	// end jQuery wrapper
})(jQuery);